import { Injectable } from "@angular/core";
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";
import { LocalStorageKey } from "src/app/enums/local-storage-key.enum";
import { EMachineType } from "src/app/enums/machine-type.enum";
import { CommonService } from "src/app/services/common/common.service";
import { FeatureToggleService } from "src/app/services/feature-toggle/feature-toggle.service";
import { BatterySettingsService } from "src/app/services/power/battery-settings/battery-settings.service";
import { PowerService } from "src/app/services/power/power.service";
import { ISectionPresenter } from '../../../models/section-presenter';

@Injectable({
	providedIn: 'root'
})

export class BatterySettingsSection implements ISectionPresenter {
	constructor(
		private power: PowerService,
		private commonService: CommonService,
		private featureToggle: FeatureToggleService
	) {}

	public async isVisible(): Promise<boolean>  {
		const machineType = this.commonService.getLocalStorageValue(LocalStorageKey.MachineType);
		const isFeatureToggleEnabled = this.isFeatureToggleEnabled()
		let isSectionAvaliable = false;

		if (isFeatureToggleEnabled) {
			switch (machineType) {
				case EMachineType.IdeaPad:
					isSectionAvaliable = await this.power.isBatterySettingsAvailableForIdeapad();
					break;
				case EMachineType.ThinkPad:
					isSectionAvaliable = await this.power.getGaugeResetCapability();
					break;
			}
		}

		return isSectionAvaliable;
	}

	public isFeatureToggleEnabled() {
		return this.featureToggle.isDeviceSettingsFeatureAvailable(DeviceSettingsFeatureToggle.PowerBatterySettings);
	}
}
